import DataChipService from './data-chip-service';
import FormatConversionService from '../format-conversion-service';
import { DataTypeEvaluator } from '@ply-io/data-types';
const evaluator = new DataTypeEvaluator();

/* Private */
function applyConversions(paramValue, nodeId, options, isRichTextEnabled) {
	let paramResult = DataChipService.toTiptapFormat(paramValue, nodeId, options);
	if (!evaluator.isHtml(paramResult)) {
		paramResult = FormatConversionService.convertTextToHtmlForTiptapPresentation(paramResult);
	}

	return isRichTextEnabled ? paramResult : paramValue;
}

const DataChipBridge = {
	applyConversions,
};

export default DataChipBridge;
